var map = {
	"./alstom.png": 6982,
	"./devrekha-india.png": 213,
	"./ge.png": 6847,
	"./gea.png": 1286,
	"./global-wind-power.png": 5379,
	"./isgec-hitachi-zosen-limited.png": 8212,
	"./isgec-titan.png": 9059,
	"./isgec.png": 5549,
	"./l-and-t-defence.png": 8934,
	"./larsen-and-toubro.png": 5302,
	"./siemens.png": 7948
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2405;